import { render, staticRenderFns } from "./ProductApplicationWorkflowForm.vue?vue&type=template&id=66312ec3&scoped=true&lang=html&"
import script from "./ProductApplicationWorkflowForm.vue?vue&type=script&lang=js&"
export * from "./ProductApplicationWorkflowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66312ec3",
  null
  
)

export default component.exports